import { render, staticRenderFns } from "./Submits.vue?vue&type=template&id=5959275c&"
import script from "./Submits.vue?vue&type=script&lang=js&"
export * from "./Submits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports